import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
} from "react-icons/fa";

const SocialShare = [
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/ife-ayelabola-74527327/" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/nomadcoder" },
  { Social: <FaTwitter />, link: "https://x.com/floormind" },
];

const Footer = () => {
  return (
    <>
      <div className="row align-items-center">
        <div className="col-md-6 my-2">
          <div className="nav justify-content-center text-center text-md-left justify-content-md-start">
            {SocialShare.map((val, i) => (
              <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank">
                {val.Social}
              </a>
            ))}
          </div>
          {/* End .nav */}
        </div>
        {/* End .col */}

        {/*<div className="col-md-6 my-2 text-center text-md-right">*/}
        {/*  <p>*/}
        {/*    © {new Date().getFullYear()} copyright{" "}*/}
        {/*    <a*/}
        {/*      href="https://themeforest.net/user/ib-themes/portfolio"*/}
        {/*      target="_blank"*/}
        {/*      rel="noreferrer"*/}
        {/*    >*/}
        {/*      ib-themes*/}
        {/*    </a>{" "}*/}
        {/*    all right reserved*/}
        {/*  </p>*/}
        {/*</div>*/}
        {/* End .col */}
      </div>
      {/* End .row */}
    </>
  );
};

export default Footer;
